import React, { useEffect, useState } from "react";
import { getTransactionHistory } from "../api/api";

export default function TransactionHistory() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const { data } = await getTransactionHistory();
        setTransactions(data);
      } catch (err) {
        console.error("Error fetching history:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, []);

  if (loading) return <p className="text-center mt-10 text-white">Loading...</p>;

  if (transactions.length === 0) {
    return <p className="text-center mt-10 text-gray-400">No transactions found.</p>;
  }

  return (
    <div className="max-w-5xl mx-auto p-4 sm:p-6 bg-gray-900 rounded-lg shadow-md">
      <h2 className="text-2xl text-white font-bold mb-6">Transaction History</h2>

      {/* Desktop Table */}
      <div className="hidden md:block overflow-x-auto rounded-md shadow-lg">
        <table className="min-w-full border border-gray-700 text-left text-white">
          <thead className="bg-gray-800 sticky top-0">
            <tr>
              <th className="px-4 py-3 border border-gray-700">Payment ID</th>
              <th className="px-4 py-3 border border-gray-700">Order ID</th>
              <th className="px-4 py-3 border border-gray-700">Amount</th>
              <th className="px-4 py-3 border border-gray-700">Status</th>
              <th className="px-4 py-3 border border-gray-700">Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((t) => (
              <tr
                key={t._id}
                className="hover:bg-gray-700 transition-colors duration-200"
              >
                <td className="px-4 py-2 border border-gray-700 break-words max-w-xs">{t.payment_id || "—"}</td>
                <td className="px-4 py-2 border border-gray-700 break-words max-w-xs">{t.order_id}</td>
                <td className="px-4 py-2 border border-gray-700">₹{(t.amount / 100).toFixed(2)}</td>
                <td className="px-4 py-2 border border-gray-700">
                  <span
                    className={`px-2 py-1 rounded text-sm ${
                      t.status === "paid"
                        ? "bg-green-100 text-green-800"
                        : t.status === "failed"
                        ? "bg-red-100 text-red-800"
                        : "bg-yellow-100 text-yellow-800"
                    }`}
                  >
                    {t.status}
                  </span>
                </td>
                <td className="px-4 py-2 border border-gray-700 whitespace-nowrap">
                  {new Date(t.createdAt).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-4">
        {transactions.map((t) => (
          <div key={t._id} className="bg-gray-800 p-4 rounded-md shadow-md">
            <div className="flex justify-between mb-2">
              <span className="font-semibold text-white">Payment ID:</span>
              <span className="text-gray-300 break-words max-w-[60%]">{t.payment_id || "—"}</span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="font-semibold text-white">Order ID:</span>
              <span className="text-gray-300 break-words max-w-[60%]">{t.order_id}</span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="font-semibold text-white">Amount:</span>
              <span className="text-gray-300">₹{(t.amount / 100).toFixed(2)}</span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="font-semibold text-white">Status:</span>
              <span
                className={`px-2 py-1 rounded text-sm ${
                  t.status === "paid"
                    ? "bg-green-100 text-green-800"
                    : t.status === "failed"
                    ? "bg-red-100 text-red-800"
                    : "bg-yellow-100 text-yellow-800"
                }`}
              >
                {t.status}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="font-semibold text-white">Date:</span>
              <span className="text-gray-300 whitespace-nowrap">
                {new Date(t.createdAt).toLocaleString()}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
